import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { TextCell } from '../../components/cells/text-cell/text-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from './profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class UnsupportedColumnService extends ProfileFieldColumnService<any> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.NORMAL;
    protected readonly DISABLE_SORT: boolean = true;
    private readonly translateService: TranslateService = inject(TranslateService);

    protected getMapper(profileField: ExtendedProfileField): (item: any) => Cell {
        return _ => {
            const label: string = this.translateService.instant('generic-overview.columns.unsupported');
            return new TextCell(label, false);
        };
    }
}
